export const isValidHttpsURL = (url) => {
    try {
        const { protocol } = new URL(url);
        // Verifica que el protocolo sea https:
        return protocol === 'https:';
    } catch (err) {
        // Si new URL(url) falla, no es una URL válida
        return false;
    }
}
